import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getOrganizations } from 'src/redux/slices/user/endpoints'
import { activateOrganization } from 'src/redux/slices/user/reducers'
import { selectActiveOrganization } from 'src/redux/slices/user/selectors'
import { SelectOnChangeEvent } from 'src/types/event-handlers'

import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core'

///// Component
const TeamSelector: React.FC = () => {
  const dispatch = useDispatch()
  const { data: teams } = getOrganizations.useQuery('')
  const activeTeam = useSelector(selectActiveOrganization)

  const makeActiveTeam = useCallback(
    (e: SelectOnChangeEvent) => {
      dispatch(activateOrganization(Number(e.target.value)))
    },
    [dispatch],
  )

  useEffect(() => {
    if (activeTeam == null && teams) {
      dispatch(activateOrganization(teams[0].organization_id))
    }
  }, [activeTeam, teams, dispatch])

  return (
    <FormControl fullWidth size='small'>
      <InputLabel id={'team-selector-label'}>Team</InputLabel>

      <Select
        labelId={'team-selector-label'}
        id={'team-selector'}
        value={activeTeam ?? ''}
        onChange={makeActiveTeam}
      >
        {teams?.map(({ organization_id, title }) => (
          <MenuItem value={organization_id} key={`org-selector-option-${organization_id}`}>
            {title}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>Select a team to view and create projects</FormHelperText>
      {/* {config.helperText && (
                <FormHelperText>{config.helperText}</FormHelperText>
            )} */}
    </FormControl>
  )
}

export default TeamSelector
